import { Table, TableBody, TableHead, TableRow, Tooltip } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  ActionIconButton,
  NoDataSkeleton,
  TableBodySkeleton,
} from '../../../common/components';
import { WAREHOUSES_TABLE_TEXTS as TEXTS } from '../constants/warehousesConstants';
import { getBranchName } from '../utils/warehousesUtils';

const textSx = { textAlign: 'left' };

const COLUMNS = [
  { key: 'code', label: TEXTS.code, sx: { ...textSx, width: 140 } },
  { key: 'name', label: TEXTS.name, sx: { ...textSx, width: 260 } },
  { key: 'branch', label: TEXTS.branch, sx: { ...textSx, width: 220 } },
  { key: 'address', label: TEXTS.address, sx: textSx },
  { key: 'actions', label: TEXTS.actions, sx: { width: 110 } },
];

/**
 * Listado de depósitos con acciones de edición y baja.
 * @param {Object} props
 * @param {Array<Object>} props.data Depósitos de la página.
 * @param {Array<Object>} props.branches Sucursales para resolver el nombre.
 * @param {boolean} props.isLoading Carga en curso.
 * @param {boolean} props.actionsDisabled Bloquea las acciones mientras hay una operación en curso.
 * @param {Function} props.onEdit Abre la edición.
 * @param {Function} props.onDelete Pide confirmar la baja.
 * @returns {JSX.Element}
 */
const WarehousesDataTable = ({
  data,
  branches,
  isLoading,
  actionsDisabled = false,
  onEdit,
  onDelete,
}) => {
  return (
    <GeneralTableBox fixedLayout minTableWidth={860}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            {COLUMNS.map((column) => (
              <HeadTableCell key={column.key} sx={column.sx}>
                {column.label}
              </HeadTableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {isLoading ? (
            <TableBodySkeleton />
          ) : data && data.length > 0 ? (
            data.map((warehouse) => {
              const branchName = getBranchName(branches, warehouse.uuid_branch);
              const address = warehouse.address || '-';
              return (
                <TableRow key={warehouse.uuid} hover>
                  <RowTableCell sx={{ ...textSx, fontWeight: 700 }} title={warehouse.code}>
                    {warehouse.code}
                  </RowTableCell>
                  <RowTableCell sx={textSx} title={warehouse.name}>
                    {warehouse.name}
                  </RowTableCell>
                  <RowTableCell sx={textSx} title={branchName}>
                    {branchName}
                  </RowTableCell>
                  <RowTableCell sx={textSx} title={address}>
                    {address}
                  </RowTableCell>
                  <RowTableCell>
                    <Tooltip title={TEXTS.edit}>
                      <span>
                        <ActionIconButton
                          variant="edit"
                          onClick={() => onEdit(warehouse)}
                          disabled={actionsDisabled}
                        />
                      </span>
                    </Tooltip>
                    <Tooltip title={TEXTS.delete}>
                      <span>
                        <ActionIconButton
                          variant="delete"
                          onClick={() => onDelete(warehouse)}
                          disabled={actionsDisabled}
                        />
                      </span>
                    </Tooltip>
                  </RowTableCell>
                </TableRow>
              );
            })
          ) : (
            <NoDataSkeleton colSpan={COLUMNS.length} message={TEXTS.empty} />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default WarehousesDataTable;
